import { render, staticRenderFns } from "./LiveNewv4.vue?vue&type=template&id=0589f466&scoped=true&"
import script from "./LiveNewv4.vue?vue&type=script&lang=js&"
export * from "./LiveNewv4.vue?vue&type=script&lang=js&"
import style0 from "./LiveNewv4.vue?vue&type=style&index=0&id=0589f466&scoped=true&lang=css&"
import style1 from "./LiveNewv4.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0589f466",
  null
  
)

export default component.exports